import { PartiStoreService } from '../../Progetti/_services/parti-store.service';
import { environment } from '../../../environments/environment';
import { ApiPathsService } from '../../api-paths.service';
import { FileStoreService } from '../../shared/_services/file-store.service';
import { Categorie } from '../../Progetti/Models/Categorie';
import { ClassicType } from '../../shared/models/ClassicType';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Prodotto } from '../../Progetti/Models/Prodotto';
import { ActivatedRoute, Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Prezzo } from '../../Progetti/Models/Prezzo';
import { ToastrService } from 'ngx-toastr';
import { RicercaPaginazione } from '../../Admin/models/sendpersonale';

@Component({
  selector: 'app-editor-prodotti',
  templateUrl: './editor-parti.component.html',
})
export class EditorPartiComponent implements OnInit {
  subscriptions: Subscription = new Subscription();
  immagineField: string = undefined;
  immaginenome: string = undefined;
  fileData;
  //hasParti: boolean = environment.Modules.PartiProdotto;
  hasCategorie: boolean = environment.PartiAddOn[0]
  submitted: boolean;
  editable: boolean;
  showaddform: boolean;
  selected: Prodotto = new Prodotto();
  infoGenerali: FormGroup;
  UnitaDiMisura: ClassicType[] = [];
  Tipologie: ClassicType[] = [];
  Categorie: Categorie[]  = [];
  CategorieSelezionate: Categorie[] = [];
  TipologieSelezionate: ClassicType[] = [];
  UnitaDiMisuraSelezionata: ClassicType[] = [];
  prezzo: string = "";
  tabellaPrezzi: Prezzo[] = []
  unitadropdownSettings:IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    textField: 'label',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: false ,
    allowRemoteDataSearch:true,
  };
  categoriedropdownSettings:IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: true,
    textField: 'categoria',
    searchPlaceholderText:"inserire almeno 3 caratteri",
    allowSearchFilter: true ,
    allowRemoteDataSearch:true,
  };
  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private progettiStore: PartiStoreService,
    private toastService: ToastrService,
    private filestore: FileStoreService,
    private apiPaths: ApiPathsService
    ) {
      this.infoGenerali = this.formBuilder.group({
        prodotto: ['', Validators.required],
        descrizione: [''],
        codice: [''],
        codice_produttore: [''],
        immagine: [''],
        prezzo:[0]
      });
    }
    get f() { return this.infoGenerali.controls; }
  ngOnInit() {
    this.progettiStore.getUnitaDiMisura();
    this.progettiStore.getTypes();
    this.subscriptions.add(this.progettiStore.$editable.subscribe(data => this.editable = data));
    this.subscriptions.add(this.progettiStore.$showAddForm.subscribe(data => this.showaddform = data));
    this.subscriptions.add(this.progettiStore.$unitaDiMisura.subscribe(data => {
      if(data !== null)
        this.UnitaDiMisura = data
    }));
    this.subscriptions.add(this.progettiStore.$types.subscribe(data => {
      if(data !== null)
        this.Tipologie = data
    }));
    this.subscriptions.add(this.progettiStore.$categorieProdottiLineare.subscribe(data => this.Categorie = data));
    if (!this.showaddform) {
      this.subscriptions.add(this.progettiStore.$selectedProdotto.subscribe((item) => {
        if (!item && !this.editable && !this.showaddform) {
          this.router.navigate([this.route.snapshot.queryParams[' progetti/parti/lista '] || 'progetti/parti/lista',]);
        } else if (item) {
          this.selected = item;
          this.compilaForm(item);
          this.filestore.SelectSection('prodotto');
          this.filestore.SetListaFile(item.files);
        }
      }));
    }
  }
  compilaForm(value: Prodotto) {
    this.CategorieSelezionate = [];
    this.UnitaDiMisuraSelezionata = [];
    this.infoGenerali.controls.prodotto.setValue(value.nome);
    this.infoGenerali.controls.descrizione.setValue(value.descrizione);
    this.infoGenerali.controls.codice.setValue(value.codice);
    this.infoGenerali.controls.codice_produttore.setValue(value.codice_produttore);
    this.infoGenerali.controls.prezzo.setValue(value.prezzo);
    if(value.categorie !== null ){
      this.CategorieSelezionate = value.categorie;
    }
    if (value.tipoObject && value.tipoObject !== null ){
      this.TipologieSelezionate = [];
      this.TipologieSelezionate.push(value.tipoObject);
    }
    if(value.prezzi !== null)
      this.tabellaPrezzi = value.prezzi;
    if (!isNaN(value.id_immagine))
      this.immagineField = `${this.apiPaths.getBaseAPI()}/file/image/${value.id_immagine.toString()}`;
  }
  getDaForm(): Prodotto {
    const nuovo = this.selected;
    nuovo.nome = this.f.prodotto.value;
    nuovo.descrizione = this.f.descrizione.value;
    nuovo.codice = this.f.codice.value;
    nuovo.codice_produttore = this.f.codice_produttore.value;
    nuovo.prezzo = this.f.prezzo.value;
    if (this.CategorieSelezionate && this.CategorieSelezionate.length > 0 && this.hasCategorie)
      nuovo.categorie = this.getidCategorie(this.CategorieSelezionate);
    if (this.TipologieSelezionate && this.TipologieSelezionate.length > 0 ) {
      console.log(this.TipologieSelezionate)
      nuovo.tipo = parseInt(this.TipologieSelezionate[0].id);
    }
    if (this.selected)
      nuovo.id = this.selected.id;
    if (this.immagineField && this.immagineField.length > 60){
      nuovo.immagine = this.immagineField;
      nuovo.file = this.immaginenome;
    }
    return nuovo;
  }
  getidCategorie(value: Categorie[]): number[]{
    const Output: number[] = [];
    value.forEach(item=> Output.push(item.id));
    return Output;
  }
  filtroUM(item: string) {
    if(item.length >= 3){
     // this.aziendeStore.getListaAziende(new RicercaPaginazione(item, 0, 1));
    }
  }
  filtroCategoria(item: string) {
    if(item.length >= 3){
      this.progettiStore.getCategorieListanofigli(new RicercaPaginazione(item, undefined, undefined));
    }
  }

  addPrezzo(){
    console.log('add');
    if (this.UnitaDiMisuraSelezionata && this.UnitaDiMisuraSelezionata.length > 0) {
      if (this.tabellaPrezzi.findIndex(x => x.um === parseInt(this.UnitaDiMisuraSelezionata[0].id)) < 0){
        this.tabellaPrezzi.push({
          prezzo: parseFloat(this.prezzo),
          um: parseInt(this.UnitaDiMisuraSelezionata[0].id),
          umlabel: this.UnitaDiMisuraSelezionata[0].label
        });
      } else if (isNaN(parseFloat(this.prezzo))) {
        this.toastService.warning("Inserire un prezzo", 'Attenzione!');
      } else {
        this.toastService.info("Questa unita di misura è stata gia inserita", 'Info!');
      }
    } else {
      this.toastService.warning("Inserire un unità di misura", 'Attenzione!');
    }
    console.log(this.tabellaPrezzi);
  }
  deletePrezzo(value){
    const idx = this.tabellaPrezzi.findIndex(x=>x.um === value.um);
    if(idx > -1)
      this.tabellaPrezzi.splice(idx,1);
  }

  async immaginecambiata(event) {
    const file: Blob = event.target.files[0];
    if (!file.type.includes("image")){
      this.toastService.warning("Questo formato non è supportato. Inserire solo immagini.", "Attenzione!")
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (reader.result.toString().length > 20){
        this.immagineField = reader.result.toString();
        this.immaginenome = event.target.files[0].name;
      }
      else
        this.immagineField = undefined;
    };

  }

  saveClick() {
    this.submitted = true;
    if (this.infoGenerali.invalid) { return; }
    this.progettiStore.getCategorieProdotti();
    if (!this.showaddform) {
      this.progettiStore.updateItems(new Prodotto(1,100, undefined, 'asc'),this.getDaForm());
      this.submitted = false;
      this.router.navigate([this.route.snapshot.queryParams[' progetti/parti/lista '] || 'progetti/parti/lista',])
    } else {
      this.progettiStore.addNewItem(this.getDaForm()).subscribe(
        data => this.router.navigate([this.route.snapshot.queryParams[' progetti/parti/lista '] || 'progetti/parti/lista',])
      );
      this.submitted = false;
    }
  }

  onFileChanged() {
    this.progettiStore.updateSelectedProdotto(this.selected);
  }

}
